import Search from "../components/template-components/search/search.js";

document
	.querySelectorAll(".js-Search")
	.forEach((element) => new Search(element));
